import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import usePricings from '@brands/hooks/usePricings';
import { CaseType } from '@brands/services/cases/types/ICase';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';

import { useAppSelector } from '../../hooks/useReduxHook';
import { UserRoleName } from '../../services/identity/types/UserProfile';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import SmileScanMobile from './Patient/SmileScanMobile';

const SmileScan: React.FC = () => {
  const user: AuthState = useAppSelector(selectAuth);
  const isPatient = user.userInfo?.role.name === UserRoleName.Patient;
  const { pricings, loading } = usePricings(isPatient);
  const smileScanOffered = pricings.some((price) => price.case_types[0] === CaseType.smile_scan);

  const getComponent = (): JSX.Element => {
    if (isPatient && loading) {
      return <Loading fullScreen />;
    }
    if (isPatient && smileScanOffered) {
      return <SmileScanMobile />;
    }
    return <NotFoundPage />;
  };

  return <div>{getComponent()}</div>;
};

export default SmileScan;
